/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import WmsCollapse from "../../../components/WmsCollapse/WmsCollapse.jsx";
import * as CarrierService from "./../../small-parcel-settings.services.jsx";
import * as GlobalService from "../../../global_services.js";
import "./new-carrier-connection.scss";
import WmsModel from "../../../components/WmsModel/WmsModel";
import WmsDropdown from "../../../components/WmsDropdown/WmsDropdown.jsx";
import _, { lowerCase } from "lodash";
import WmsButton from "../../../components/WmsButton/WmsButton.jsx";
import DynamicCarrierFormComponent from "./dynamic-carrier-form.component";
import EditDynamicCarrierFormComponent from "./edit-dynamic-carrier-form.component";
import WmsCheckBox from "../../../components/WmsCheckBox/WmsCheckBox.jsx";
import WmsInput from "../../../components/WmsInput/WmsInput.jsx";

declare var window: any;

interface Props {
    selector: string;
    isOpenCarrierConnectionModel: boolean;
    sharedSelectedCarrierAccountData: any;
    sharedCarrierConnectionFlow: any;
    closeCarrierConnection: () => void;
    sharedFacilityOption: any;
    onResetSelectionAndGridRefresh: () => void;
    sharedShipEngineCarrier: any;
    sharedSelectedCustomer: any;
}

const stepOneDefaultObj = {
    selectedContentType: "",
    selectedFacilityIndex: "",
    selectedCustomerIndex: "",
    selectedCarrierIndex: "",
    selectedProviderIndex: "",
    IncludeShippingCost: false,
};

const pitneyBowesAccountDefaultObj = {
    pitneyBowesUsername: "",
    pitneyBowesPassword: "",
    providerUsername: "",
    providerOrganizationNumber: "",
    providerConnectToken: "",
};

interface ProviderObj {
    CarrierCode: string;
    DisplayName: string;
}

const DynamicCarrierConnectionModel: React.FC<Props> = (props: Props): any => {
    const carrierAccountSchema = GlobalService.GetDynamicCarrierAccountSchema();
    const rights = GlobalService.GetRights();
    let selectedCustomerName = props.sharedSelectedCustomer.name;

    const getResponsiveDimensions = () => {
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;

        // Calculate responsive width (80% of window width, with min/max constraints)
        const responsiveWidth = Math.min(Math.max(windowWidth * 0.8, 800), 1200);

        // Calculate responsive height - ensure footer is visible by leaving space at bottom
        // WmsModel uses 200px total padding (100px top + 100px bottom)
        // Add 50px top and bottom margins when carrier list is shown
        const topBottomMargin = isCarrierAccList ? 100 : 0; // 50px top + 50px bottom
        const maxAvailableHeight = (windowHeight - topBottomMargin) as number; // Extra 50px to ensure footer visibility
        const responsiveHeight = Math.min(Math.max(windowHeight * 0.55, 600), maxAvailableHeight);

        return {
            width: responsiveWidth,
            height: responsiveHeight,
        };
    };

    const [modelDimensions, setModelDimensions] = useState(() => {
        return {
            width: 800,
            height: 750,
        };
    });
    const [selectedFacilityObj, setSelectedFacilityObj] = useState(null);
    const [selectedCustomerObj, setSelectedCustomerObj] = useState(null);
    const [connectionTermsOfService, setConnectionTermsOfService] = useState([]);
    const [connectionSchemaXgroupings, setConnectionSchemaXgroupings] = useState([]);
    const [connectionDisplay, setConnectionDisplay] = useState(null);
    const [connectionSchemaProperties, setConnectionSchemaProperties] = useState([]);
    const [connectionSchemaRequired, setConnectionSchemaRequired] = useState([]);
    const [editDynamicCarrierObj, setEditDynamicCarrierObj] = useState({});
    const [isOpenPitneyBowesModel, setIsOpenPitneyBowesModel] = useState(false);
    const [isEditDynamicCarrier, setIsEditDynamicCarrier] = useState(false);
    const [selectedCarrier, setSelectedCarrier] = useState("");
    const [selectedProvider, setSelectedProvider] = useState("");
    const [selectedCarrierCode, setSelectedCarrierCode] = useState("");
    const [currentCarrierImgUrl, setCurrentCarrierImgUrl] = useState("");
    const [totalSteps, setTotalSteps] = useState(0);
    const [currentStep, setCurrentStep] = useState(1);
    const [isCalledParcelApi, setIsCalledParcelApi] = useState(false);
    const [pitneyBowesAccountObj, setPitneyBowesAccountObj] = useState(pitneyBowesAccountDefaultObj);
    const [currentLoginLabel, setCurrentLoginLabel] = useState("Login");
    const [stepOneObject, setStepOneObject] = useState(stepOneDefaultObj);
    const [providerIndex, setProviderIndex] = useState("");
    const [carrierOptions, setCarrierOptions] = useState([]);
    const [providerOptions, setProviderOptions] = useState([]);
    const [carrierConnectionBtnLoader, setCarrierConnectionBtnLoader] = useState(false);
    const [checkCarrierConnectionBtnLoader, setCheckCarrierConnectionBtnLoader] = useState(false);
    const [authUrl, setAuthUrl] = useState("");
    const [carrierAccList, setCarrierAccList] = useState([]);
    const [isCarrierAccList, setIsCarrierAccList] = useState(false);
    const [isCarrierConnectionWorking, setIsCarrierConnectionWorking] = useState("None");
    const [isAuthUrl, setIsAuthUrl] = useState(false);
    const [authFlowCurrentStep, setAuthFlowCurrentStep] = useState(0);
    const [isCombinedAuthFlow, setIsCombinedAuthFlow] = useState(false);
    const [editCarrierModalTitle, setEditCarrierModalTitle] = useState("Edit Carrier");
    const [pitneyBowesErrorMessage, setPitneyBowesErrorMessage] = useState("");
    const [selectedProviderObj, setSelectedProviderObj] = useState<ProviderObj>({
        CarrierCode: "",
        DisplayName: "",
    });
    const modalId = "dynamicCarrierConnection";
    const customerAccountText = "Customer Account";
    const carrierStampsDotComText = "Stamps.com";
    const carrierEndiciaText = "Endicia";
    const warehouseAccountText = "Warehouse Account";
    const xGroupingText = "x-groupings";
    const customerOptions = GlobalService.getCustomerList();
    const facilityOption = GlobalService.getFacilityList(false);
    const isEnableProvider =
        rights.hasOwnProperty("Shipping.SmallParcelEnabled") &&
        rights["Integrations.SmallParcelPartner"] === "ParcelApi";
    const carrierElementClass = isEnableProvider ? "new-connection-four-elements" : "new-connection-three-elements";
    const currentCarrierImgUrlText = "assets/images/3PL_Logo_Orange.png";

    const normalizeCarrierName = (name: string) =>
        String(name || "")
            .replace(/[^a-zA-Z0-9]/g, "")
            .toLowerCase();

    const getSchemaCarrierCode = (carrierName: string, providerName: string) => {
        const candidateNames = [carrierName];
        if (["tusk", "tusklogistics"].includes(normalizeCarrierName(carrierName))) {
            candidateNames.push("Tusk", "Tusk Logistics");
        }
        const normalizedCandidates = candidateNames.map(normalizeCarrierName);
        const providerEntries = Object.entries(carrierAccountSchema || {}).filter(
            ([schemaProviderName]) =>
                !providerName || normalizeCarrierName(schemaProviderName) === normalizeCarrierName(providerName)
        );

        for (const [, providerDefinition] of providerEntries) {
            const carriers = (providerDefinition as any)?.carriers || {};
            for (const [carrierCode, carrierDefinition] of Object.entries(carriers) as any) {
                const identityNames = [
                    carrierCode,
                    carrierDefinition?.carrierName,
                    ...(carrierDefinition?.carrierNameAliases || []),
                ].filter(Boolean);
                if (identityNames.some((name) => normalizedCandidates.includes(normalizeCarrierName(name)))) {
                    return carrierCode;
                }
            }
        }
        return "";
    };

    const setCarrierListHeight = () => {
        // Account for modal header, footer, padding, and 50px top/bottom margins
        const availableHeight = window.innerHeight - 450; // 350 + 100 (50px top + 50px bottom margins)
        const gridHeight = Math.max(Math.min(availableHeight, 600), 300); // Min 300px, Max 600px
        const contentHeight = gridHeight - 80; // Account for grid header

        document.documentElement.style.setProperty("--carrier-list-height", `${gridHeight}px`);
        document.documentElement.style.setProperty("--carrier-list-content-height", `${contentHeight}px`);
    };

    useEffect(() => {
        getCarrierOptions();

        // Add window resize listener to update modal dimensions dynamically
        const handleResize = () => {
            // Only apply responsive dimensions when carrier account list is displayed
            if (isCarrierAccList) {
                const dimensions = getResponsiveDimensions();
                setModelDimensions((prev) => ({
                    ...prev,
                    width: dimensions.width,
                    height: dimensions.height,
                }));
                // Update carrier list height if it's currently displayed
                setTimeout(setCarrierListHeight, 50);
            }
        };

        window.addEventListener("resize", handleResize);

        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener("resize", handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCarrierAccList]);

    useEffect(() => {
        setIsOpenPitneyBowesModel(false);

        if (props.sharedCarrierConnectionFlow === "edit" && carrierOptions.length > 0) {
            kendo.ui.progress($("#" + modalId), true);
            let hasProviderSettings = true;
            CarrierService.getDynamicCarrierDetail(
                props.sharedSelectedCarrierAccountData.ShipEngineId,
                props.sharedSelectedCustomer.id,
                hasProviderSettings
            ).then((response: any) => {
                if (response) {
                    // Set Dynamic Carrier Options and Object
                    let selectedProviderForEdit = "";
                    if (props.sharedSelectedCarrierAccountData.Provider) {
                        selectedProviderForEdit = props.sharedSelectedCarrierAccountData.Provider;
                    }

                    // Get carrierCode from the carrierOptions
                    let selectedCarrierNameForEdit = props.sharedSelectedCarrierAccountData?.Carrier || "";
                    const schemaCarrierCode = getSchemaCarrierCode(selectedCarrierNameForEdit, selectedProviderForEdit);
                    const carrierCode =
                        carrierOptions.find((carrier) => carrier.Carrier === selectedCarrierNameForEdit)?.CarrierCode ||
                        schemaCarrierCode ||
                        lowerCase(selectedCarrierNameForEdit);
                    setDynamicCarrierOptions(selectedCarrierNameForEdit, carrierCode);
                    setEditDynamicCarrierObj(response.payload);

                    // Set Edit Carrier Object
                    response.payload.provider = selectedProviderForEdit;
                    response.payload.carrierName = carrierCode;
                    response.payload.nickname = props.sharedSelectedCarrierAccountData.NickName;
                    response.payload.accountNumber = props.sharedSelectedCarrierAccountData.AccountNumber;
                    response.payload.shipEngineId = props.sharedSelectedCarrierAccountData.ShipEngineId;
                    response.payload.carrierCustomerId = props.sharedSelectedCustomer.id;

                    if (carrierAccountSchema) {
                        const tmpCarriers = carrierAccountSchema[`${selectedProviderForEdit}`].carriers;
                        for (const carrier in tmpCarriers) {
                            if (carrierCode === carrier) {
                                setCurrentCarrierImgUrl(tmpCarriers[`${carrier}`].logo || currentCarrierImgUrlText);
                                // Set Edit Carrier Modal Title
                                if (
                                    tmpCarriers[`${carrier}`].connectionUpdateSchema &&
                                    tmpCarriers[`${carrier}`].connectionUpdateSchema["title"]
                                ) {
                                    setEditCarrierModalTitle(tmpCarriers[`${carrier}`].connectionUpdateSchema["title"]);
                                }
                                // If X-grouping then set
                                if (
                                    tmpCarriers[`${carrier}`].connectionUpdateSchema &&
                                    tmpCarriers[`${carrier}`].connectionUpdateSchema[`${xGroupingText}`]
                                ) {
                                    setConnectionSchemaXgroupings(
                                        tmpCarriers[`${carrier}`].connectionUpdateSchema[`${xGroupingText}`]
                                    );
                                } else {
                                    setConnectionSchemaXgroupings([]);
                                }
                                // Set Properties
                                if (
                                    tmpCarriers[`${carrier}`].connectionUpdateSchema &&
                                    tmpCarriers[`${carrier}`].connectionUpdateSchema["properties"]
                                ) {
                                    setConnectionSchemaProperties(
                                        tmpCarriers[`${carrier}`].connectionUpdateSchema["properties"]
                                    );
                                    setIsEditDynamicCarrier(true);
                                } else {
                                    setConnectionSchemaProperties([]);
                                    setIsEditDynamicCarrier(false);
                                }
                                // Set Reuired
                                if (
                                    tmpCarriers[`${carrier}`].connectionUpdateSchema &&
                                    tmpCarriers[`${carrier}`].connectionUpdateSchema["required"]
                                ) {
                                    setConnectionSchemaRequired(
                                        tmpCarriers[`${carrier}`].connectionUpdateSchema["required"]
                                    );
                                } else {
                                    setConnectionSchemaRequired([]);
                                }
                                kendo.ui.progress($("#" + modalId), false);
                            }
                        }
                    }
                    kendo.ui.progress($("#" + modalId), false);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carrierOptions]);

    const getCarrierOptions = () => {
        var carrierOptions = props.sharedShipEngineCarrier;
        setCarrierOptions(carrierOptions);
    };

    const handleChangeEvent = (e: any) => {
        let name = e.target.name;
        let tmpStepOneObj = Object.assign({}, stepOneObject);

        if (e.target.type === "checkbox") {
            tmpStepOneObj[`${name}`] = !tmpStepOneObj[`${name}`];
        } else {
            tmpStepOneObj[`${name}`] = e.target.value;
        }

        if (name === "selectedContentType" && e.target.value === warehouseAccountText) {
            tmpStepOneObj.IncludeShippingCost = true;
        }

        if (name === "selectedContentType" && (!e.target.value || e.target.value === customerAccountText)) {
            tmpStepOneObj.IncludeShippingCost = false;
        }

        if (
            name === "selectedCustomerIndex" &&
            tmpStepOneObj.selectedContentType === customerAccountText &&
            e.target.value
        ) {
            let tmpCustomerObj = customerOptions[e.target.value];
            selectedCustomerName = tmpCustomerObj.name;
            setSelectedCustomerObj(tmpCustomerObj);
        }
        if (name === "selectedFacilityIndex" && e.target.value) {
            let tmpFacilityObj = facilityOption[e.target.value];
            setSelectedFacilityObj(tmpFacilityObj);
        }
        if (name === "selectedProviderIndex" && e.target.value) {
            let tmpProviderObj = providerOptions[e.target.value];
            tmpStepOneObj.selectedProviderIndex = tmpProviderObj.Code;
            setProviderIndex(e.target.value);
            setSelectedProvider(tmpProviderObj.DisplayName);
        }

        if (
            (name === "selectedContentType" &&
                (!e.target.value || tmpStepOneObj.selectedContentType !== customerAccountText)) ||
            (name === "selectedCustomerIndex" && !e.target.value)
        ) {
            selectedCustomerName = props.sharedSelectedCustomer.name;
        }

        if (name === "selectedCarrierIndex") {
            if (e.target.value) {
                let tmpSelectedCarrier = carrierOptions[e.target.value].Carrier;
                let tmpSelectedCarrierCode = carrierOptions[e.target.value].CarrierCode;

                setDynamicCarrierOptions(tmpSelectedCarrier, tmpSelectedCarrierCode);

                // Check If Flexport Carrier Then Select Direct To Carrier Provider
                if (tmpSelectedCarrier === "Flexport") {
                    tmpStepOneObj.selectedProviderIndex = "flexport";
                } else {
                    tmpStepOneObj.selectedProviderIndex = "";
                    setProviderIndex("");
                }
            } else {
                setProviderOptions([]);
                tmpStepOneObj.selectedProviderIndex = "";
            }
        }
        setStepOneObject(tmpStepOneObj);
    };

    const handleCheckboxChangeEvent = (key: string) => {
        setStepOneObject((prev) => ({
            ...prev,
            [key]: !prev[`${key}`],
        }));
    };

    const setDynamicCarrierOptions = async (tmpSelectedCarrier: string, tmpSelectedCarrierCode: string) => {
        let totalSteps = 2;
        let currentStep = 1;
        let currentCarrierImgUrl = currentCarrierImgUrlText;
        let currentLoginLabel = "Login";
        // Set Provider Options
        let providerOptions = [];
        if (carrierAccountSchema) {
            for (const providerName in carrierAccountSchema) {
                const tmpCarriers = carrierAccountSchema[`${providerName}`].carriers;
                const tmpSettings = carrierAccountSchema[`${providerName}`].settings;
                for (const carrier in tmpCarriers) {
                    if (tmpSelectedCarrierCode === carrier && tmpCarriers[`${carrier}`].connectionSchema) {
                        currentCarrierImgUrl = tmpCarriers[`${carrier}`].logo;
                        providerOptions.push({
                            DisplayName: carrierAccountSchema[`${providerName}`].name,
                            Code: providerName,
                            Settings: tmpSettings,
                        });
                    }
                }
            }
        }

        setProviderOptions(providerOptions);
        setSelectedCarrier(tmpSelectedCarrier);
        setSelectedCarrierCode(tmpSelectedCarrierCode);
        setCurrentCarrierImgUrl(currentCarrierImgUrl);
        setTotalSteps(totalSteps);
        setCurrentStep(currentStep);
        setCurrentLoginLabel(currentLoginLabel);
    };

    const handelPitneyBowesChangeEvent = (e: any) => {
        const { name, value } = e.target;
        setPitneyBowesAccountObj((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const addPitneyBowesAccount = () => {
        let providerAccountObj = {};
        switch (stepOneObject.selectedProviderIndex) {
            case "pbex":
            case "pitneyBowes":
                providerAccountObj = {
                    Username: pitneyBowesAccountObj.pitneyBowesUsername,
                    Password: pitneyBowesAccountObj.pitneyBowesPassword,
                    Provider: "pitneyBowes",
                };
                break;
            case "buku":
            case "bukuShip":
                providerAccountObj = {
                    Username: pitneyBowesAccountObj.providerUsername,
                    OrganizationNumber: pitneyBowesAccountObj.providerOrganizationNumber,
                    ConnectToken: pitneyBowesAccountObj.providerConnectToken,
                    Provider: "bukuShip",
                };
                break;
            default:
                providerAccountObj = {};
        }
        setCarrierConnectionBtnLoader(true);
        setPitneyBowesErrorMessage("");
        CarrierService.createProviderAccount(providerAccountObj)
            .then((response: any) => {
                if (response.status === 200 || response.status === 204) {
                    moveNextStep();
                } else {
                    if (response && response.response.status === 403) {
                        setPitneyBowesErrorMessage(window.translate("Label_incorrect_pitney_bowes_account"));
                    }
                }
            })
            .finally(() => {
                setCarrierConnectionBtnLoader(false);
            });
    };

    const movePreviousStep = () => {
        if (isAuthUrl && authFlowCurrentStep > 0) {
            let tmpAuthFlowStep = authFlowCurrentStep - 1;
            // Reset carrier connection auth flow when user back from first step
            if (tmpAuthFlowStep === 0) {
                setIsAuthUrl(false);
                setIsCombinedAuthFlow(false); // Reset combined flow flag when exiting auth
            }
            setAuthFlowCurrentStep(tmpAuthFlowStep);
        } else {
            let prvStep = currentStep - 1;
            if (isOpenPitneyBowesModel) {
                prvStep = currentStep;
            }

            if (currentStep === 1 && isCarrierAccList) {
                setIsCarrierAccList(false);
            }
            setCurrentStep(prvStep);
            setIsOpenPitneyBowesModel(false);
        }
    };

    const moveNextStep = async () => {
        kendo.ui.progress($("#" + modalId), true);
        // var isOpenPitneyBowesModel = false;
        var isParcelMappingAPiCalled = false;
        let nxtStep = currentStep + 1;

        let selectedProviderIndex = stepOneObject.selectedProviderIndex;
        let tmpSelectedProviderObj = _.find(providerOptions, function (o: any) {
            return o.Code === selectedProviderIndex;
        });

        setSelectedProviderObj(tmpSelectedProviderObj);
        let selectedProvider = carrierAccountSchema[`${selectedProviderIndex}`];
        let isUserConnectionInput =
            selectedProvider.settings && selectedProvider.settings.requireUserConnectionInput
                ? selectedProvider.settings.requireUserConnectionInput.value
                : true;
        if (
            // !isOpenPitneyBowesModel &&
            currentStep === 1 &&
            selectedProvider.connectionSchema &&
            isUserConnectionInput
        ) {
            setCarrierConnectionBtnLoader(true);
            let tmpSelectedProviderIndex = selectedProviderIndex;
            if (tmpSelectedProviderIndex === "pbex") {
                tmpSelectedProviderIndex = "pitneyBowes";
            } else if (tmpSelectedProviderIndex === "buku") {
                tmpSelectedProviderIndex = "bukuShip";
            }
            await CarrierService.getProviderDetail(tmpSelectedProviderIndex)
                .then((response: any) => {
                    if (!response.data) {
                        setTotalSteps(2);
                        nxtStep = currentStep + 1;
                        // isOpenPitneyBowesModel = true;
                        isParcelMappingAPiCalled = true;
                        setIsCalledParcelApi(true);
                        let currentCarrierImgUrl = currentCarrierImgUrlText;
                        if (carrierAccountSchema) {
                            for (const providerName in carrierAccountSchema) {
                                if (selectedProviderIndex === providerName) {
                                    currentCarrierImgUrl = carrierAccountSchema[`${providerName}`].logo;
                                }
                            }
                        }
                        setCurrentCarrierImgUrl(currentCarrierImgUrl);
                        setConnectionTermsOfService([]);
                        setConnectionSchemaXgroupings([]);
                        setConnectionSchemaProperties(selectedProvider.connectionSchema.properties);
                        setConnectionSchemaRequired(selectedProvider.connectionSchema.required);
                        setConnectionDisplay(selectedProvider.connectionDisplay);
                        kendo.ui.progress($("#" + modalId), false);
                    }
                })
                .finally(() => {
                    setCarrierConnectionBtnLoader(false);
                });
        }
        if (selectedCarrier === "USPS") {
            let totalSteps = 2;
            let currentCarrierImgUrl = currentCarrierImgUrlText;
            let currentLoginLabel = "Login";
            if (carrierAccountSchema) {
                for (const providerName in carrierAccountSchema) {
                    if (selectedProviderIndex === providerName) {
                        currentCarrierImgUrl = carrierAccountSchema[`${providerName}`].logo;
                    }
                }
            }
            setCurrentCarrierImgUrl(currentCarrierImgUrl);
            setTotalSteps(totalSteps);
            setCurrentLoginLabel(currentLoginLabel);
        }
        setCurrentStep(nxtStep);
        // setIsOpenPitneyBowesModel(isOpenPitneyBowesModel);
        if (!isParcelMappingAPiCalled && carrierAccountSchema && selectedProviderIndex) {
            const tmpCarriers = carrierAccountSchema[`${selectedProviderIndex}`].carriers;
            setCarrierConnectionFormData(tmpCarriers);
        }
    };
    const setCarrierConnectionFormData = (tmpCarriers: any) => {
        setConnectionDisplay(null);
        for (const carrier in tmpCarriers) {
            if (selectedCarrierCode === carrier) {
                setCurrentCarrierImgUrl(tmpCarriers[`${carrier}`].logo);
                // If X-grouping then set
                if (tmpCarriers[`${carrier}`].connectionSchema[`${xGroupingText}`]) {
                    setConnectionSchemaXgroupings(tmpCarriers[`${carrier}`].connectionSchema[`${xGroupingText}`]);
                } else {
                    setConnectionSchemaXgroupings([]);
                }
                // If HasTerms then set
                if (tmpCarriers[`${carrier}`].hasTerms) {
                    setTotalSteps(3);
                    setConnectionTermsOfService(carrierAccountSchema["terms"][`${carrier}`]);
                } else {
                    setTotalSteps(2);
                    setConnectionTermsOfService([]);
                }
                // Set Properties
                setConnectionSchemaProperties(tmpCarriers[`${carrier}`].connectionSchema["properties"]);
                // If Required then set
                if (tmpCarriers[`${carrier}`].connectionSchema["required"]) {
                    setConnectionSchemaRequired(tmpCarriers[`${carrier}`].connectionSchema["required"]);
                } else {
                    setConnectionSchemaRequired([]);
                }
                kendo.ui.progress($("#" + modalId), false);
            }
        }
    };

    const onClickCreatePitneyAccount = () => {
        if (stepOneObject.selectedProviderIndex === "pitneyBowes" || stepOneObject.selectedProviderIndex === "pbex") {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            window.open("https://www.pbshippingmerchant.pitneybowes.com/home?developerID=95490479", "_blank");
        } else {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            window.open("https://www.bukuship.com/extensiv", "_blank");
        }
    };

    const isDisabledNextButton = () => {
        const isStepOne = currentStep === 1;
        const isBukuShip = stepOneObject.selectedProviderIndex === "bukuShip";
        const isBuku = stepOneObject.selectedProviderIndex === "buku";
        const isPitneyBowes = stepOneObject.selectedProviderIndex === "pitneyBowes";
        const isPbex = stepOneObject.selectedProviderIndex === "pbex";
        const selectedContentType = stepOneObject.selectedContentType;

        const isBukuShipInvalid =
            !pitneyBowesAccountObj.providerUsername ||
            !pitneyBowesAccountObj.providerOrganizationNumber ||
            !pitneyBowesAccountObj.providerConnectToken;

        const isPitneyBowesInvalid =
            !pitneyBowesAccountObj.pitneyBowesUsername || !pitneyBowesAccountObj.pitneyBowesPassword;

        const isWarehouseInvalid = selectedContentType === warehouseAccountText && !stepOneObject.selectedFacilityIndex;

        const isCustomerInvalid = selectedContentType === customerAccountText && !stepOneObject.selectedCustomerIndex;

        const isCarrierOrProviderInvalid =
            !stepOneObject.selectedCarrierIndex || (isEnableProvider && !stepOneObject.selectedProviderIndex);

        if (isOpenPitneyBowesModel) {
            return (
                isStepOne &&
                ((isBukuShip && isBukuShipInvalid) ||
                    (isBuku && isBukuShipInvalid) ||
                    (isPbex && isPitneyBowesInvalid) ||
                    (isPitneyBowes && isPitneyBowesInvalid))
            );
        }

        return (
            isStepOne && (!selectedContentType || isWarehouseInvalid || isCustomerInvalid || isCarrierOrProviderInvalid)
        );
    };

    const setupCarrierAccountsList = (carrierAccounts: any[]) => {
        setCarrierAccList(carrierAccounts);
        // Use responsive dimensions when carrier account list is displayed
        const dimensions = getResponsiveDimensions();
        setModelDimensions({
            width: dimensions.width,
            height: dimensions.height,
        });
        setIsCarrierAccList(true);
        // Set responsive height for carrier list after state update
        setTimeout(() => {
            setCarrierListHeight();
            // Force a small delay to ensure proper centering after all updates
            setTimeout(() => {
                window.dispatchEvent(new Event("resize"));
            }, 50);
        }, 100);
    };

    const addDynamicCarrier = (dynamicCarrierObj: any, isFormResetLink: boolean) => {
        setCarrierConnectionBtnLoader(true);
        let tmpDynamicCarrierObj = {
            provider: "",
            carrier: "",
            customerId: "",
            facilityId: "",
            nickname: dynamicCarrierObj.nickname,
            includeShippingCost: stepOneObject.IncludeShippingCost,
            data: dynamicCarrierObj,
            ShipEngineId: "",
        };

        let carrierObj = carrierOptions[stepOneObject.selectedCarrierIndex];
        let facilityObj = facilityOption[stepOneObject.selectedFacilityIndex];
        let customerObj = customerOptions[stepOneObject.selectedCustomerIndex];
        tmpDynamicCarrierObj.carrier = carrierObj.Carrier;

        if (isEnableProvider) {
            tmpDynamicCarrierObj.provider = stepOneObject.selectedProviderIndex;
            if (tmpDynamicCarrierObj.carrier === "USPS") {
                if (stepOneObject.selectedProviderIndex === carrierStampsDotComText) {
                    tmpDynamicCarrierObj.provider = "shipEngine";
                    tmpDynamicCarrierObj.carrier = carrierStampsDotComText;
                } else if (stepOneObject.selectedProviderIndex === carrierEndiciaText) {
                    tmpDynamicCarrierObj.provider = "shipEngine";
                    tmpDynamicCarrierObj.carrier = carrierEndiciaText;
                } else if (stepOneObject.selectedProviderIndex === "bukuShip") {
                    tmpDynamicCarrierObj.carrier = "Buku";
                }
            }
        }

        if (facilityObj && stepOneObject.selectedContentType === warehouseAccountText) {
            tmpDynamicCarrierObj.facilityId = facilityObj.id;
        } else {
            tmpDynamicCarrierObj.customerId = customerObj.id;
        }
        let providerSchema = carrierAccountSchema[selectedProviderObj[`Code`]];
        let carrierSettings = null;
        if (selectedProviderObj) {
            carrierSettings = providerSchema.carriers[`${selectedCarrierCode}`];
        }
        CarrierService.addDynamicCarrier(tmpDynamicCarrierObj, carrierSettings, isCalledParcelApi)
            .then((response: any) => {
                // Combined flow: Auth URL with carrier accounts flag
                if (
                    response &&
                    response.data.authUrl &&
                    response.data.carrierAccounts &&
                    response.data.carrierAccounts.length > 0 &&
                    (response.status === 200 || response.status === 204)
                ) {
                    // Step 1: Set up auth flow first
                    let tmpAuthFlowCurrentStep = 1;
                    if (isFormResetLink) {
                        tmpAuthFlowCurrentStep = 2;
                    }
                    setAuthUrl(response.data.authUrl);
                    setIsAuthUrl(true);
                    setCarrierConnectionBtnLoader(false);
                    setIsCarrierConnectionWorking("None");
                    setCheckCarrierConnectionBtnLoader(false);
                    setAuthFlowCurrentStep(tmpAuthFlowCurrentStep);

                    // Store carrier accounts from first response - no need for second API call
                    setCarrierAccList(response.data.carrierAccounts);

                    // Set flag to indicate this is a combined flow
                    // After auth completes, we'll display the stored carrier accounts
                    setIsCombinedAuthFlow(true);
                }
                // Auth URL only flow
                else if (response && response.data.authUrl && (response.status === 200 || response.status === 204)) {
                    let tmpAuthFlowCurrentStep = 1;
                    if (isFormResetLink) {
                        tmpAuthFlowCurrentStep = 2;
                    }
                    setAuthUrl(response.data.authUrl);
                    setIsAuthUrl(true);
                    setCarrierConnectionBtnLoader(false);
                    setIsCarrierConnectionWorking("None");
                    setCheckCarrierConnectionBtnLoader(false);
                    setAuthFlowCurrentStep(tmpAuthFlowCurrentStep);
                } else if (
                    response &&
                    response.data.carrierAccounts &&
                    response.data.carrierAccounts.length > 0 &&
                    !response.data.authUrl &&
                    (response.status === 200 || response.status === 204)
                ) {
                    setupCarrierAccountsList(response.data.carrierAccounts);
                } else if (response && !response.data.authUrl && (response.status === 200 || response.status === 204)) {
                    if (response && response.data.ShipEngineId) {
                        // Update Ship Engine Settings
                        tmpDynamicCarrierObj.ShipEngineId = response.data.ShipEngineId;
                        if (
                            tmpDynamicCarrierObj.carrier === "UPS" ||
                            (tmpDynamicCarrierObj.carrier === "FedEx" && tmpDynamicCarrierObj.provider === "shipEngine")
                        ) {
                            CarrierService.updateCarrier(tmpDynamicCarrierObj);
                        }
                    }
                    GlobalService.notification("success", window.translate("New_carrier_Connection_Success"));
                    props.onResetSelectionAndGridRefresh();
                    setTimeout(() => {
                        props.closeCarrierConnection();
                    }, 10);
                } else if (isCalledParcelApi && response) {
                    let selectedProviderIndex = stepOneObject.selectedProviderIndex;
                    const tmpCarriers = carrierAccountSchema[`${selectedProviderIndex}`].carriers;
                    setCarrierConnectionFormData(tmpCarriers);
                    setIsCalledParcelApi(false);
                }
                // Check Is Auth URL
                else {
                    GlobalService.notification("error", window.translate("Authorize_With_Failed"));
                    setCarrierConnectionBtnLoader(false);
                }
            })
            .finally(() => {
                setCarrierConnectionBtnLoader(false);
            });
    };

    const addAccountListCarrier = (resourceList: any) => {
        setCarrierConnectionBtnLoader(true);
        let payload = {
            customerId: selectedCustomerObj ? selectedCustomerObj.id : null,
            facilityId: selectedFacilityObj ? selectedFacilityObj.id : null,
            includeShippingCost: stepOneObject.IncludeShippingCost,
            ResourceList: resourceList,
        };
        CarrierService.createCarrierAccounts(payload)
            .then((response: any) => {
                GlobalService.notification("success", window.translate("New_carrier_Connection_Success"));
                props.onResetSelectionAndGridRefresh();
                setTimeout(() => {
                    props.closeCarrierConnection();
                }, 10);
            })
            .finally(() => {
                setCarrierConnectionBtnLoader(false);
            });
    };

    const checkConnectionAuthorized = (dynamicCarrierObj: any, isHaveUpsAuthorization: any) => {
        if (authFlowCurrentStep > 0) {
            let tmpAuthFlowCurrentStep = authFlowCurrentStep + 1;
            if (isHaveUpsAuthorization && authUrl) {
                // eslint-disable-next-line security/detect-non-literal-fs-filename
                window.open(authUrl, "_blank", "width=800,height=750,top=200,left=560,resizable=yes");
            }
            setAuthFlowCurrentStep(tmpAuthFlowCurrentStep);
            return true;
        }
        setCarrierConnectionBtnLoader(true);
        let tmpDynamicCarrierObj = {
            provider: "",
            carrier: "",
            customerId: "",
            facilityId: "",
            nickname: dynamicCarrierObj.nickname,
            includeShippingCost: stepOneObject.IncludeShippingCost,
            data: dynamicCarrierObj,
            ShipEngineId: "",
            SyncWithProvider: "",
        };

        let carrierObj = carrierOptions[stepOneObject.selectedCarrierIndex];
        let facilityObj = facilityOption[stepOneObject.selectedFacilityIndex];
        let customerObj = customerOptions[stepOneObject.selectedCustomerIndex];
        tmpDynamicCarrierObj.carrier = carrierObj.Carrier;

        if (isEnableProvider) {
            tmpDynamicCarrierObj.provider = stepOneObject.selectedProviderIndex;
            if (tmpDynamicCarrierObj.carrier === "USPS") {
                if (stepOneObject.selectedProviderIndex === carrierStampsDotComText) {
                    tmpDynamicCarrierObj.provider = "shipEngine";
                    tmpDynamicCarrierObj.carrier = carrierStampsDotComText;
                } else if (stepOneObject.selectedProviderIndex === carrierEndiciaText) {
                    tmpDynamicCarrierObj.provider = "shipEngine";
                    tmpDynamicCarrierObj.carrier = carrierEndiciaText;
                } else if (stepOneObject.selectedProviderIndex === "bukuShip") {
                    tmpDynamicCarrierObj.carrier = "Buku";
                }
            }
        }

        if (facilityObj && stepOneObject.selectedContentType === warehouseAccountText) {
            tmpDynamicCarrierObj.facilityId = facilityObj.id;
        } else {
            tmpDynamicCarrierObj.customerId = customerObj.id;
        }

        tmpDynamicCarrierObj.SyncWithProvider = tmpDynamicCarrierObj.provider;
        let providerSchema = carrierAccountSchema[selectedProviderObj[`Code`]];
        let carrierSettings = null;
        if (selectedProviderObj) {
            carrierSettings = providerSchema.carriers[`${selectedCarrierCode}`];
        }
        CarrierService.addDynamicCarrier(tmpDynamicCarrierObj, carrierSettings, isCalledParcelApi)
            .then((response: any) => {
                if (response && response.data.ShipEngineId) {
                    // Update Ship Engine Settings
                    tmpDynamicCarrierObj.ShipEngineId = response.data.ShipEngineId;
                    if (
                        tmpDynamicCarrierObj.carrier === "UPS" ||
                        (tmpDynamicCarrierObj.carrier === "FedEx" && tmpDynamicCarrierObj.provider === "shipEngine")
                    ) {
                        CarrierService.updateCarrier(tmpDynamicCarrierObj);
                    }
                }
                GlobalService.notification("success", window.translate("New_carrier_Connection_Success"));
                props.onResetSelectionAndGridRefresh();
                setTimeout(() => {
                    props.closeCarrierConnection();
                }, 10);
            })
            .finally(() => {
                startOverConnectionAuthorize();
            });
    };

    const checkConnectionAuthorizedFinal = (dynamicCarrierObj: any) => {
        setCheckCarrierConnectionBtnLoader(true);
        let tmpDynamicCarrierObj = {
            provider: "",
            carrier: "",
            customerId: "",
            facilityId: "",
            nickname: dynamicCarrierObj.nickname,
            includeShippingCost: stepOneObject.IncludeShippingCost,
            data: dynamicCarrierObj,
            ShipEngineId: "",
            SyncWithProvider: "",
        };

        let carrierObj = carrierOptions[stepOneObject.selectedCarrierIndex];
        let facilityObj = facilityOption[stepOneObject.selectedFacilityIndex];
        let customerObj = customerOptions[stepOneObject.selectedCustomerIndex];
        tmpDynamicCarrierObj.carrier = carrierObj.Carrier;

        if (isEnableProvider) {
            tmpDynamicCarrierObj.provider = stepOneObject.selectedProviderIndex;
            if (tmpDynamicCarrierObj.carrier === "USPS") {
                if (stepOneObject.selectedProviderIndex === carrierStampsDotComText) {
                    tmpDynamicCarrierObj.provider = "shipEngine";
                    tmpDynamicCarrierObj.carrier = carrierStampsDotComText;
                } else if (stepOneObject.selectedProviderIndex === carrierEndiciaText) {
                    tmpDynamicCarrierObj.provider = "shipEngine";
                    tmpDynamicCarrierObj.carrier = carrierEndiciaText;
                } else if (stepOneObject.selectedProviderIndex === "bukuShip") {
                    tmpDynamicCarrierObj.carrier = "Buku";
                }
            }
        }

        if (facilityObj && stepOneObject.selectedContentType === warehouseAccountText) {
            tmpDynamicCarrierObj.facilityId = facilityObj.id;
        } else {
            tmpDynamicCarrierObj.customerId = customerObj.id;
        }

        tmpDynamicCarrierObj.SyncWithProvider = tmpDynamicCarrierObj.provider;
        let providerSchema = carrierAccountSchema[selectedProviderObj[`Code`]];
        let carrierSettings = null;
        if (selectedProviderObj) {
            carrierSettings = providerSchema.carriers[`${selectedCarrierCode}`];
        }
        CarrierService.addDynamicCarrier(tmpDynamicCarrierObj, carrierSettings, isCalledParcelApi)
            .then((response: any) => {
                if (response && response.data.ShipEngineId) {
                    // Update Ship Engine Settings
                    tmpDynamicCarrierObj.ShipEngineId = response.data.ShipEngineId;
                    if (
                        tmpDynamicCarrierObj.carrier === "UPS" ||
                        (tmpDynamicCarrierObj.carrier === "FedEx" && tmpDynamicCarrierObj.provider === "shipEngine")
                    ) {
                        CarrierService.updateCarrier(tmpDynamicCarrierObj);
                    }
                }
                if (response.status === 200 || response.status === 204) {
                    setIsCarrierConnectionWorking("Yes");
                    setCheckCarrierConnectionBtnLoader(false);

                    // Check if this is a combined auth + carrier accounts flow
                    if (isCombinedAuthFlow) {
                        // Step 2: Display carrier accounts from first response
                        setIsAuthUrl(false);
                        setAuthFlowCurrentStep(0);
                        setIsCombinedAuthFlow(false); // Reset the flag

                        if (carrierAccList && carrierAccList.length > 0) {
                            setupCarrierAccountsList(carrierAccList);
                        } else {
                            // Fallback if carrier accounts weren't stored
                            GlobalService.notification("success", window.translate("New_carrier_Connection_Success"));
                            props.onResetSelectionAndGridRefresh();
                            setTimeout(() => {
                                props.closeCarrierConnection();
                            }, 10);
                        }
                    } else {
                        // Normal flow: refresh grid and continue
                        props.onResetSelectionAndGridRefresh();
                    }
                } else {
                    setIsCarrierConnectionWorking("No");
                    setCheckCarrierConnectionBtnLoader(false);
                }
            })
            .finally(() => {
                setCheckCarrierConnectionBtnLoader(false);
            });
    };

    const startOverConnectionAuthorize = () => {
        setCarrierConnectionBtnLoader(false);
        setIsAuthUrl(false);
        setAuthUrl("");
        setAuthFlowCurrentStep(0);
        setIsCombinedAuthFlow(false); // Reset combined flow flag
    };

    const updateDynamicCarrier = (editDynamicCarrierObj: any) => {
        setCarrierConnectionBtnLoader(true);

        let tmpEditDynamicCarrierObj = {
            provider: editDynamicCarrierObj.provider,
            carrier: editDynamicCarrierObj.carrierName,
            customerId: editDynamicCarrierObj.carrierCustomerId,
            nickname: editDynamicCarrierObj.nickname,
            accountNumber: editDynamicCarrierObj.accountNumber,
            data: editDynamicCarrierObj,
            ShipEngineId: editDynamicCarrierObj.shipEngineId,
            includeShippingCost: editDynamicCarrierObj.includeShippingCost,
        };

        CarrierService.updateDynamicCarrier(tmpEditDynamicCarrierObj, isEditDynamicCarrier)
            .then((response: any) => {
                if (response) {
                    GlobalService.notification("success", window.translate("Label_Carrier_Update_Success"));
                    props.onResetSelectionAndGridRefresh();
                    setTimeout(() => {
                        props.closeCarrierConnection();
                    }, 10);
                }
            })
            .finally(() => {
                setCarrierConnectionBtnLoader(false);
            });
    };
    const resetAccountCarrierList = () => {
        setIsCarrierAccList(false);
        setModelDimensions({
            width: 800,
            height: 750,
        });
        // Clean up CSS custom properties
        document.documentElement.style.removeProperty("--carrier-list-height");
        document.documentElement.style.removeProperty("--carrier-list-content-height");

        setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        }, 100);
    };

    return (
        <WmsModel
            id={modalId}
            title={
                isOpenPitneyBowesModel
                    ? window
                          .translate("Label_Add_Pitney_Bowes_Carrier_Model")
                          // eslint-disable-next-line sonarjs/no-duplicate-string
                          .replace(new RegExp("{provider}", "gi"), selectedProviderObj?.DisplayName || "")
                    : props.sharedCarrierConnectionFlow === "create"
                    ? window.translate("Title_New_carrier_Connection_Model")
                    : editCarrierModalTitle
            }
            width={modelDimensions.width}
            height={modelDimensions.height}
            maxHeight={window.innerHeight - 100} // Override default maxHeight calculation
            class={"new-carrier-connection-wrapper" + (isCarrierAccList ? " carrier-account-list" : "")}
            onCloseFunc={props.closeCarrierConnection}
            isOpen={props.isOpenCarrierConnectionModel}
            customClass="wms-model-new-ui-wrapper"
        >
            {/* First Step */}
            {props.sharedCarrierConnectionFlow === "create" && currentStep === 1 && (
                <>
                    <div className="model-content-wrapper">
                        {/* isOpenPitneyBowesModel is FALSE */}
                        {!isOpenPitneyBowesModel && (
                            <div className={"wms-carrier-connection " + carrierElementClass}>
                                <WmsCollapse
                                    id={"dynamicCarrierSelectConnection"}
                                    headerLabel={window.translate("Label_Carrier_Select")}
                                    showCollapseText={false}
                                    showCollapseIcon={false}
                                >
                                    <WmsDropdown
                                        id="selectedContentType"
                                        name="selectedContentType"
                                        label={window.translate("Label_Connection_Type")}
                                        wmsSelector={props.selector + "contentType"}
                                        onChangeFunc={handleChangeEvent}
                                        value={stepOneObject.selectedContentType}
                                        options={[
                                            {
                                                Text: warehouseAccountText,
                                                Value: warehouseAccountText,
                                            },
                                            {
                                                Text: customerAccountText,
                                                Value: customerAccountText,
                                            },
                                        ]}
                                        valueField="Value"
                                        textField="Text"
                                        parentClassName="form_group"
                                        blankFirstOption={true}
                                        extraWrapperClass={"new-connection-first-element"}
                                    />
                                    {stepOneObject.selectedContentType === customerAccountText ? (
                                        <WmsDropdown
                                            id="selectedCustomerIndex"
                                            name="selectedCustomerIndex"
                                            label={window.translate("FindOrders_Lbl_Customer")}
                                            wmsSelector={props.selector + "customer"}
                                            onChangeFunc={handleChangeEvent}
                                            value={stepOneObject.selectedCustomerIndex}
                                            options={customerOptions}
                                            valueField="id"
                                            textField="name"
                                            parentClassName="form_group"
                                            applyIndex={true}
                                            blankFirstOption={true}
                                            extraWrapperClass={"new-connection-second-element"}
                                        />
                                    ) : (
                                        <WmsDropdown
                                            id="selectedFacilityIndex"
                                            name="selectedFacilityIndex"
                                            label={window.translate("Label_Warehouse_Text")}
                                            wmsSelector={props.selector + "facility"}
                                            onChangeFunc={handleChangeEvent}
                                            value={stepOneObject.selectedFacilityIndex}
                                            options={facilityOption}
                                            valueField="id"
                                            textField="name"
                                            parentClassName="form_group"
                                            applyIndex={true}
                                            blankFirstOption={true}
                                            extraWrapperClass={"new-connection-second-element"}
                                        />
                                    )}

                                    <WmsDropdown
                                        id="selectedCarrierIndex"
                                        name="selectedCarrierIndex"
                                        label={window.translate("Label_Carrier")}
                                        wmsSelector={props.selector + "carrier"}
                                        onChangeFunc={handleChangeEvent}
                                        value={stepOneObject.selectedCarrierIndex}
                                        options={carrierOptions}
                                        valueField="Carrier"
                                        textField="DisplayName"
                                        parentClassName="form_group"
                                        applyIndex={true}
                                        blankFirstOption={true}
                                        extraWrapperClass={"new-connection-third-element"}
                                    />

                                    {isEnableProvider && (
                                        <WmsDropdown
                                            id="selectedProviderIndex"
                                            name="selectedProviderIndex"
                                            label={window.translate("Label_Provider")}
                                            wmsSelector={props.selector + "service"}
                                            onChangeFunc={handleChangeEvent}
                                            value={providerIndex}
                                            options={providerOptions}
                                            valueField="Code"
                                            textField="DisplayName"
                                            parentClassName="form_group"
                                            applyIndex={true}
                                            blankFirstOption={true}
                                            disabled={stepOneObject.selectedCarrierIndex === "" ? true : false}
                                            extraWrapperClass={"new-connection-third-element"}
                                        />
                                    )}
                                    {stepOneObject.selectedContentType && (
                                        <div className="display-include-cost">
                                            <WmsCheckBox
                                                id={"IncludeShippingCost"}
                                                name={"IncludeShippingCost"}
                                                onChangeFunc={() => handleCheckboxChangeEvent("IncludeShippingCost")}
                                                label={window.translate("Label_Include_Shipping_Cost")}
                                                checked={stepOneObject.IncludeShippingCost}
                                                wmsSelector={props.selector + "IncludeShippingCost"}
                                                disabled={!stepOneObject.selectedContentType}
                                            />
                                        </div>
                                    )}
                                    {stepOneObject.selectedContentType === customerAccountText && (
                                        <div className="display-include-cost">
                                            <p>
                                                For this account, label charges will be recorded and added to your
                                                invoice for <b>{selectedCustomerName}</b>.
                                            </p>
                                        </div>
                                    )}
                                    {stepOneObject.selectedContentType === warehouseAccountText && (
                                        <div className="display-include-cost">
                                            <p>
                                                For this account, label charges will be recorded and added to your
                                                invoice for <b>all customers in this warehouse.</b>
                                            </p>
                                        </div>
                                    )}
                                    {stepOneObject.IncludeShippingCost &&
                                        stepOneObject.selectedContentType === customerAccountText && (
                                            <div className="display-include-cost">
                                                <div className="alert-text-wrapper">
                                                    <i className="far fa-triangle-exclamation" aria-hidden="true"></i>
                                                    <span>
                                                        {window.translate("Label_Include_Shipping_Cost_Warning")}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                </WmsCollapse>
                            </div>
                        )}
                        {/* isOpenPitneyBowesModel is TRUE */}
                        {isOpenPitneyBowesModel && (
                            <div className="pitney-bowes-connection-step-block">
                                <div className="image-section">
                                    <img src={currentCarrierImgUrl} alt={currentCarrierImgUrl} />
                                </div>
                                <WmsCollapse
                                    id={"pitneyBowesConnectionLoginDetail"}
                                    headerLabel={window.translate("Label_Account_Login")}
                                    showCollapseText={false}
                                    showCollapseIcon={false}
                                >
                                    <div className="title">
                                        <div className="wms-sprite fa fa-exclamation-triangle"></div>
                                        {stepOneObject.selectedProviderIndex &&
                                            (stepOneObject.selectedProviderIndex === "pitneyBowes" ||
                                                stepOneObject.selectedProviderIndex === "pbex") && (
                                                <span>
                                                    {window.translate("Label_pitney_bowes_account_connect_new")}
                                                </span>
                                            )}
                                        {((stepOneObject.selectedProviderIndex &&
                                            stepOneObject.selectedProviderIndex === "bukuShip") ||
                                            stepOneObject.selectedProviderIndex === "buku") && (
                                            <span>
                                                {window
                                                    .translate("Label_pitney_bowes_account_connect")
                                                    .replace(
                                                        new RegExp("{carrier_account}", "gi"),
                                                        carrierOptions[stepOneObject.selectedCarrierIndex]
                                                            ? carrierOptions[stepOneObject.selectedCarrierIndex].Carrier
                                                            : ""
                                                    )
                                                    .replace(
                                                        // eslint-disable-next-line sonarjs/no-duplicate-string
                                                        new RegExp("{provider}", "gi"),
                                                        selectedProviderObj?.DisplayName || ""
                                                    )}
                                            </span>
                                        )}
                                    </div>
                                    {pitneyBowesErrorMessage !== "" && (
                                        <div className="pitneyBoweserror">
                                            <div className="wms-sprite fa fa-exclamation-triangle"></div>
                                            <span>{pitneyBowesErrorMessage}</span>
                                        </div>
                                    )}
                                    {(stepOneObject.selectedProviderIndex === "pitneyBowes" ||
                                        stepOneObject.selectedProviderIndex === "pbex") && (
                                        <div className="pitney-bowes-middel-wrapper">
                                            <div className="pitney-bowes-credentials">
                                                <WmsInput
                                                    id="pitney-bowes-username"
                                                    inputName="pitneyBowesUsername"
                                                    autoComplete="off"
                                                    wmsSelector={props.selector + "pitneyBowesUsername"}
                                                    onChangeFunc={handelPitneyBowesChangeEvent}
                                                    label={window.translate("Label_Username")}
                                                    value={pitneyBowesAccountObj.pitneyBowesUsername}
                                                />
                                                <WmsInput
                                                    inputType="password"
                                                    id="pitney-bowes-password"
                                                    inputName="pitneyBowesPassword"
                                                    autoComplete="new-password"
                                                    wmsSelector={props.selector + "pitneyBowesPassword"}
                                                    onChangeFunc={handelPitneyBowesChangeEvent}
                                                    label={window.translate("Login_Lbl_Password")}
                                                    value={pitneyBowesAccountObj.pitneyBowesPassword}
                                                />
                                            </div>
                                            <div className="pitney-bowes-seprator-wrapper">
                                                <div className="pitney-bowes-seprator-word">OR</div>
                                            </div>
                                            <div className="pitney-bowes-create-account-btn">
                                                <WmsButton
                                                    label={window
                                                        .translate("Label_new_pitney_bowes_account")
                                                        .replace(
                                                            new RegExp("{provider}", "gi"),
                                                            selectedProviderObj?.DisplayName || ""
                                                        )}
                                                    buttonType="green"
                                                    wmsSelector={props.selector + "pitneyBowesCreateAccount"}
                                                    onClickFunc={onClickCreatePitneyAccount}
                                                    icon="fa-plus"
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {(stepOneObject.selectedProviderIndex === "bukuShip" ||
                                        stepOneObject.selectedProviderIndex === "buku") && (
                                        <div className="pitney-bowes-middel-wrapper">
                                            <div className="pitney-bowes-credentials">
                                                <WmsInput
                                                    id="providerUsername"
                                                    inputName="providerUsername"
                                                    autoComplete="off"
                                                    wmsSelector={props.selector + "providerUsername"}
                                                    onChangeFunc={handelPitneyBowesChangeEvent}
                                                    label={window.translate("Label_Username")}
                                                    value={pitneyBowesAccountObj.providerUsername}
                                                />
                                                <WmsInput
                                                    inputType="text"
                                                    id="providerOrganizationNumber"
                                                    inputName="providerOrganizationNumber"
                                                    wmsSelector={props.selector + "providerOrganizationNumber"}
                                                    onChangeFunc={handelPitneyBowesChangeEvent}
                                                    label={window.translate("Lbl_Organization_Number")}
                                                    value={pitneyBowesAccountObj.providerOrganizationNumber}
                                                />
                                                <WmsInput
                                                    inputType="text"
                                                    id="providerConnectToken"
                                                    inputName="providerConnectToken"
                                                    wmsSelector={props.selector + "providerConnectToken"}
                                                    onChangeFunc={handelPitneyBowesChangeEvent}
                                                    label={window.translate("Lbl_Connect_Token")}
                                                    value={pitneyBowesAccountObj.providerConnectToken}
                                                />
                                            </div>
                                            <div className="pitney-bowes-seprator-wrapper">
                                                <div className="pitney-bowes-seprator-word">OR</div>
                                            </div>
                                            <div className="pitney-bowes-create-account-btn">
                                                <WmsButton
                                                    label={window
                                                        .translate("Label_new_pitney_bowes_account")
                                                        .replace(
                                                            new RegExp("{provider}", "gi"),
                                                            selectedProviderObj?.DisplayName || ""
                                                        )}
                                                    buttonType="green"
                                                    wmsSelector={props.selector + "pitneyBowesCreateAccount"}
                                                    onClickFunc={onClickCreatePitneyAccount}
                                                    icon="fa-plus"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </WmsCollapse>
                            </div>
                        )}
                    </div>
                    <div className="footer-btn-holder">
                        <WmsButton
                            label={window.translate("Label_Close")}
                            buttonType="orange"
                            wmsSelector={props.selector + "exitDynamicConnection"}
                            onClickFunc={props.closeCarrierConnection}
                            icon="fa-times-circle-o"
                        />
                        {props.sharedCarrierConnectionFlow === "create" && (
                            <WmsButton
                                label={window.translate("Label_Previous")}
                                wmsSelector={props.selector + "previous"}
                                onClickFunc={movePreviousStep}
                                icon="fa-caret-left"
                                disabled={currentStep === 1 && !isOpenPitneyBowesModel}
                            />
                        )}
                        {props.sharedCarrierConnectionFlow === "create" && (
                            <WmsButton
                                label={
                                    isOpenPitneyBowesModel
                                        ? window.translate("Label_Carrier_Account_Login")
                                        : window.translate("Label_Next")
                                }
                                wmsSelector={props.selector + "next"}
                                onClickFunc={isOpenPitneyBowesModel ? addPitneyBowesAccount : moveNextStep}
                                icon={isOpenPitneyBowesModel ? "fa-sign-in" : "fa-caret-right"}
                                loading={carrierConnectionBtnLoader}
                                disabled={isDisabledNextButton()}
                            />
                        )}
                    </div>
                </>
            )}

            {/* Second Step */}
            {props.sharedCarrierConnectionFlow === "create" && currentStep === 2 && (
                <>
                    <DynamicCarrierFormComponent
                        selector={props.selector}
                        connectionTermsOfService={connectionTermsOfService}
                        connectionSchemaXgroupings={connectionSchemaXgroupings}
                        connectionSchemaProperties={connectionSchemaProperties}
                        connectionSchemaRequired={connectionSchemaRequired}
                        closeCarrierConnection={props.closeCarrierConnection}
                        selectedCarrier={selectedCarrier}
                        selectedProvider={selectedProvider}
                        currentCarrierImgUrl={currentCarrierImgUrl}
                        movePreviousStep={movePreviousStep}
                        totalSteps={totalSteps}
                        currentLoginLabel={currentLoginLabel}
                        addDynamicCarrier={addDynamicCarrier}
                        addAccountListCarrier={addAccountListCarrier}
                        carrierConnectionBtnLoader={carrierConnectionBtnLoader}
                        authUrl={authUrl}
                        isAuthUrl={isAuthUrl}
                        carrierAccList={carrierAccList}
                        isCarrierAccList={isCarrierAccList}
                        authFlowCurrentStep={authFlowCurrentStep}
                        setIsCarrierAccList={resetAccountCarrierList}
                        isCarrierConnectionWorking={isCarrierConnectionWorking}
                        startOverConnectionAuthorize={startOverConnectionAuthorize}
                        checkConnectionAuthorized={checkConnectionAuthorized}
                        checkCarrierConnectionBtnLoader={checkCarrierConnectionBtnLoader}
                        checkConnectionAuthorizedFinal={checkConnectionAuthorizedFinal}
                        selectedFacilityObj={selectedFacilityObj}
                        selectedCustomerObj={selectedCustomerObj}
                        selectedCustomerName={selectedCustomerName}
                        connectionDisplay={connectionDisplay}
                    />
                </>
            )}

            {/* Edit Carrier Flow */}
            {props.sharedCarrierConnectionFlow === "edit" && (
                <>
                    <EditDynamicCarrierFormComponent
                        selector={props.selector}
                        connectionSchemaXgroupings={connectionSchemaXgroupings}
                        connectionSchemaProperties={connectionSchemaProperties}
                        connectionSchemaRequired={connectionSchemaRequired}
                        editDynamicCarrierObj={editDynamicCarrierObj}
                        closeCarrierConnection={props.closeCarrierConnection}
                        selectedCarrier={selectedCarrier}
                        currentCarrierImgUrl={currentCarrierImgUrl}
                        updateDynamicCarrier={updateDynamicCarrier}
                        carrierConnectionBtnLoader={carrierConnectionBtnLoader}
                        isEditDynamicCarrier={isEditDynamicCarrier}
                        selectedCustomerName={selectedCustomerName}
                    />
                </>
            )}
        </WmsModel>
    );
};

DynamicCarrierConnectionModel.propTypes = {};

export default React.memo(DynamicCarrierConnectionModel);
